import { createSelectorsFromModel } from '@/helpers/redux';

const model = {
    id: null,
    loading: false,
    error: null,
};

export const selectors = createSelectorsFromModel(
    (state) => state.flights,
    model,
);

export default model;
